module.exports = __webpack_public_path__ + "static/media/Abhay_Aggarwal_S21.8e1e6013.png";